module.exports = {
    staticGetters: {
        test: state => state.test,
        messageType: state => state.messageType,
        audioType: state => state.audioType,
        contactListType: state => state.contactListType,
        callers: state => state.callers,
        lists: state => state.lists,
        listsFull: state => state.listsFull,
        file: state => state.file,
        message: state => state.message,
        selectedCaller: state => state.selectedCaller,
        selectedList: state => state.selectedList,
        callerName: state => state.callerName,
        callerPhoneNumber: state => state.callerPhoneNumber,
        frequency: state => state.frequency,
        startDate: state => state.startDate,
        startTime: state => state.startTime,
        audioUploadType: state => state.audioUploadType,
        recording: state => state.recording,
        recordings: state => state.recordings,
        jobId: state => state.jobId,
        status: state => state.status,
        currentCampaignId: state => state.currentCampaignId,
        campaigns: state => state.campaigns,
    }
}